"use client"

import ElysiumLogo from "@/public/ElysiumLogo";
import { Close, Error, QrCode2 } from "@mui/icons-material";
import { Box, Button, Dialog, DialogActions, IconButton, Stack, Typography } from "@mui/material";
import { useRouter } from "next/navigation";
import { useState } from "react";
import QrReader from 'react-qr-scanner'

export default function PublicPatientScanner() {

    const router = useRouter()

    // STATES
    const [openScanner, setOpenScanner] = useState(false);
    const [scannerMesage, setScannerMessage] = useState("");

    const [patientInquiry, setPatientInquiry] = useState("");
    const [isValidHex, setIsValidHex] = useState(false);
    const [patientId, setPatientId] = useState("")
    const [error, setError] = useState(false)
    const [errorText, setErrorText] = useState("")
    const [openDialog, setOpenDialog] = useState(false)

    // HEX ID Checker

    const checkString = () => {
        
        const ObjectId = require("mongoose").Types.ObjectId;

        if (ObjectId.isValid(patientInquiry)) {
            setPatientInquiry("")
            setError(false)
            setErrorText("")
            router.push(`/patientscan/public/${patientInquiry}/labs`)

            return
        } else {
            setError(true)
            setErrorText("Invalid Patient ID")
            return
        }

    }

    // QR CODE CAMERA SCANNER - 11/22/2024
    // FOR DOCUMENTATION : https://www.npmjs.com/package/react-qr-scanner
    const handleScan = (e) => {
        if (!e) {
            return
        } 
        if (patientInquiry) {
            setOpenScanner(false)
            setScannerMessage("")
            checkString()
        }
        else {
            const patientString = e.text
            setPatientInquiry(patientString)
            setScannerMessage("Please keep QR in view")
            setTimeout(() => {
                setScannerMessage("Please close and try again")
            }, 5000);
        }
    }


    return (
        <main className="grid place-items-center h-screen">
            <Box sx={{padding: 5}}>
                <Stack alignItems={"center"} gap={2}>
                    <Typography>Scan your patient QR to view your results</Typography>
                    <Button startIcon={<QrCode2 />} onClick={() => setOpenScanner(true)}>Scanner</Button>
                    <Stack alignItems={"center"} gap={1}>
                        <Typography fontSize={"small"}>A product of</Typography>
                        <ElysiumLogo noText width={200}/>
                    </Stack>
                </Stack>
            </Box>

            <Dialog
            open={error}
            >
                <Box sx={{padding: 5}}>
                    <Stack gap={2}>
                        <Stack direction={"row"} alignItems={"center"} gap={1}>
                            <Error color="error" />
                            <Typography sx={{fontWeight: 700}} color="error">{errorText}</Typography>
                        </Stack>
                        <Button color="error" onClick={() => setError(false)}>Try again</Button>
                    </Stack>
                </Box>
            </Dialog>


            <Dialog
            open={openScanner}
            onClose={() => {setOpenScanner(false)}}
            >
                <DialogActions>
                    <IconButton color="error" onClick={() => {setOpenScanner(false)}}>
                        <Close />
                    </IconButton>
                </DialogActions>
                <Stack alignItems={"center"} gap={1} className="p-5">
                    <Typography fontSize={"small"}>Scan Patient QR Code</Typography>
                    <QrReader 
                    delay={1000}
                    style={{height: 200, width: 200}}
                    onScan={(e) => {handleScan(e)}}
                    onError={(e) => {console.log(e)}}
                    constraints={{
                        audio: false,
                        video: { facingMode: "environment" }
                    }}
                    />
                    <Typography fontSize={"small"} color={"error"}>{scannerMesage}</Typography>
                </Stack>
            </Dialog>



        </main>
    )
}